<template>
  <div class="home">
    <van-sticky>
      <van-search
        v-model="scenicName"
        placeholder="搜索景区"
        input-align="center"
        @search="search"
      />
      <van-dropdown-menu active-color="#00BC7A">
        <!-- 城市筛选 -->
        <van-dropdown-item title="城市" ref="item0">
          <div class="dropdown-box">
            <ul class="dropdown-select-first">
              <li class="dropdown-option active van-ellipsis">{{ provSel }}</li>
            </ul>
            <ul class="dropdown-select-sceond">
              <li
                class="dropdown-option"
                :class="{ active: item.value == citySel.value }"
                v-for="item in cityData"
                v-bind:key="item.value"
                @click="cityChange(item)"
              >
                {{ item.label }}
                <img
                  class="icon"
                  :src="picUrl + 'qunaer/scenic/active.png'"
                  alt=""
                  v-if="item.value == citySel.value"
                />
              </li>
            </ul>
          </div>
        </van-dropdown-item>
        <!-- 类型筛选 -->
        <van-dropdown-item title="景区等级" ref="item1">
          <div class="dropdown-box">
            <ul class="dropdown-select-first">
              <li class="dropdown-option van-ellipsis active">
                {{ scenicTypeSel.label }}
              </li>
            </ul>
            <ul class="dropdown-select-sceond">
              <li
                class="dropdown-option van-ellipsis"
                :class="{ active: item.value == scenicTypeSel.value }"
                v-for="item in scenicTypeArr"
                v-bind:key="item.value"
                @click="scenicTypeChange(item)"
              >
                {{ item.label }}
                <img
                  class="icon"
                  :src="picUrl + 'qunaer/scenic/active.png'"
                  alt=""
                  v-if="item.value == scenicTypeSel.value"
                />
              </li>
            </ul>
          </div>
        </van-dropdown-item>
      </van-dropdown-menu>
    </van-sticky>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        :finished-text="finishedText"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
      >
        <template v-if="listData.length">
          <div class="h30"></div>
          <ul class="lists">
            <li
              class="list"
              v-for="item in listData"
              v-bind:key="item.scenicId"
              @click="scenicGo(item)"
            >
              <div
                class="pic"
                :style="{
                  'background-image': 'url(' + picUrl + item['scenicUrl'] + ')',
                }"
              ></div>
              <div class="text">
                <div class="name-leave">
                  <p class="name van-ellipsis">{{ item.scenicName }}</p>
                  <img
                    class="leave"
                    :src="picUrl + 'qunaer/scenic/level01.png'"
                    alt=""
                    v-if="item.scenicType == '3A景区'"
                  />
                  <img
                    class="leave"
                    :src="picUrl + 'qunaer/scenic/level02.png'"
                    alt=""
                    v-if="item.scenicType == '4A景区'"
                  />
                  <img
                    class="leave"
                    :src="picUrl + 'qunaer/scenic/level03.png'"
                    alt=""
                    v-if="item.scenicType == '5A景区'"
                  />
                  <img
                    class="leave"
                    :src="picUrl + 'qunaer/scenic/level04.png'"
                    alt=""
                    v-if="item.scenicType == '主题乐园'"
                  />
                </div>
                <div
                  class="descri van-multi-ellipsis--l2"
                  v-html="descriTrans(item)"
                ></div>
                <div class="address-distance">
                  <p class="address van-ellipsis">
                    <span class="iconfont iconsite icon"></span
                    >{{ item.address }}
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </template>
      </van-list>
      <div style="height: 5rem" v-if="listData.length"></div>
    </van-pull-refresh>
    <template v-if="!listData.length && !loading && !error">
      <van-empty description="暂无景区" />
    </template>
    <van-tabbar
      v-model="tabbarActive"
      active-color="#00BC7A"
      inactive-color="#999"
      @change="tabbarChange"
    >
      <van-tabbar-item>
        <span>首页</span>
        <template #icon="props">
          <img :src="props.active ? icon[0].active : icon[0].inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item icon="search">
        <span>预约</span>
        <template #icon="props">
          <img :src="props.active ? icon[1].active : icon[1].inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
// @ is an alias to /src
import {
  Sticky,
  Search,
  DropdownMenu,
  DropdownItem,
  PullRefresh,
  List,
  Empty,
  Tabbar,
  TabbarItem,
  Toast,
} from "vant"

import tabbar00 from "./../assets/tabbar/tabbar00.png"
import tabbar00_ from "./../assets/tabbar/tabbar00_.png"
import tabbar01 from "./../assets/tabbar/tabbar01.png"
import tabbar01_ from "./../assets/tabbar/tabbar01_.png"

import { setToken, getPicUrl } from '../utils/auth'
import { getUserInfo, getCityByProvinceList, queryScenicList as getList } from '../api/index'

export default {
  name: "Home",
  components: {
    [Sticky.name]: Sticky,
    [Search.name]: Search,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Empty.name]: Empty,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Toast.name]: Toast,
  },
  data() {
    return {
      picUrl: getPicUrl(),
      listData: [],
      loading: true,
      finished: false,
      error: false,
      refreshing: false,
      finishedText: "",
      pageNum: 0,
      pageSize: 10,
      pageTotal: 0,
      latitude: "",
      longitude: "",
      province: "",
      scenicName: "",
      scenicTypeArr: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "3A景区",
          value: "3A",
        },
        {
          label: "4A景区",
          value: "4A",
        },
        {
          label: "5A景区",
          value: "5A",
        },
        {
          label: "主题乐园",
          value: "主题乐园",
        },
      ],
      scenicTypeSel: {
        label: "全部",
        value: "",
      },
      provSel: "",
      cityData: [],
      citySel: {
        label: "全部",
        value: "",
      },
      businessId: "",
      tabbarActive: 0,
      icon: [
        {
          active: tabbar00,
          inactive: tabbar00_,
        },
        {
          active: tabbar01,
          inactive: tabbar01_,
        },
      ],
    };
  },
  created() {
    const that = this
    this.businessId = this.$route.params.businessId
    this.getUserInfo()
      .then(function (res) {
        if (res.data.code !== 200) {
          throw res.data.msg
        }
        if (res.data.code === 200) {
          setToken(res.data.data.token)
          const arriveProvince = res.data.data.qunaerUser.arriveProvince
          that.provSel = arriveProvince
          that.getCityByProvinceList()
          that.onLoad()
        }
      })
      .catch((err) => {
        that.$toast(err)
      })
  },
  methods: {
    // tabbar切换
    tabbarChange(index) {
      if (index == 1) {
        this.$router.push({
          name: "Order",
          params: { businessId: this.businessId },
        });
      }
    },
    // 根据省份获取城市列表
    async getCityByProvinceList() {
      const that = this;
      const province = that.provSel
      const res = await getCityByProvinceList({ province })
      if (res.data.code == 200) {
        const cityList = res.data.data
        cityList.unshift("全部")
        that.cityData = cityList.map((item) => {
          return {
            label: item,
            value: item == "全部" ? "" : item
          }
        })
      }
    },
    // 省份选择
    provChange() {
      this.onRefresh()
    },
    // 城市选择
    cityChange(item) {
      this.$refs.item0.toggle()
      this.citySel = item
      this.onRefresh()
    },
    // 景区类型选择
    scenicTypeChange(item) {
      this.$refs.item1.toggle()
      this.scenicTypeSel = item
      this.onRefresh()
    },
    // 景区列表
    getScenicList() {
      const that = this
      const city = this.citySel.value
      const scenicType = this.scenicTypeSel.value
      const { businessId, pageNum, pageSize, latitude, longitude, scenicName } = this
      getList({ businessId, pageNum, pageSize, latitude, longitude, scenicName, scenicType, city })
        .then((res) => {
          if (that.refreshing) {
            that.refreshing = false;
          }
          if (res.data.code != 200) {
            throw res.data.msg;
          }
          if (res.data.code == 200) {
            const total = res.data.data.total;
            let listData = [];
            if (that.pageNum < 2) {
              listData = res.data.data.list || [];
              document.documentElement.scrollTop = 0;
            }

            if (that.pageNum > 1) {
              listData = that.listData.concat(res.data.data.list);
            }

            this.listData = listData;
            // 加载状态结束
            that.loading = false;

            // 数据全部加载完成
            if (listData.length >= total) {
              that.finished = true;
              that.finishedText = listData.length ? "已经到底了" : "";
            }
          }
        })
        .catch(() => {
          that.loading = false;
          that.error = true;
          that.pageNum = that.pageNum - 1;
        });
    },
    // 翻页数据
    onLoad() {
      this.finishedText = this.pageNum < 1 ? "" : "已经到底了"
      this.pageNum = this.pageNum + 1
      this.getScenicList()
    },
    // 下拉刷新
    onRefresh() {
      this.pageNum = 0
      this.finished = false

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    // 景区跳转
    scenicGo(item) {
      this.$router.push({
        name: "ScenicDetail",
        params: { businessId: this.businessId, scenicId: item.scenicId }
      })
    },
    // 获取用户信息
    getUserInfo() {
      const { businessId } = this
      return getUserInfo({ businessId })
    },
    // 搜索
    search(value) {
      this.scenicName = value
      this.onRefresh()
    },
    descriTrans(item) {
      return item.introduction.replace(/href/g, "")
    }
  }
}
</script>

<style scoped>
/* 选项卡 */
.dropdown-box {
  display: flex;
  width: 100%;
  height: 450px;
  font-size: 28px;
  background: #F7F7F7;
}
.dropdown-select-first {
  width: 245px;
  height: 100%;
  text-align: center;
  overflow-y: auto;
}
.dropdown-select-first .dropdown-option {
  padding: 0 30px;
  width: calc(100% - 60px);
  height: 90px;
  line-height: 90px;
}
.dropdown-select-first .dropdown-option.active {
  background: #FFF;
}
.dropdown-select-sceond {
  padding: 0 40px;
  width: calc(100% - 325px);
  height: 100%;
  background: #FFF;
  overflow-y: auto;
}
.dropdown-select-sceond .dropdown-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 90px;
  line-height: 90px;
}
.dropdown-select-sceond .dropdown-option.active {
  font-weight: bold;
}
.dropdown-select-sceond .dropdown-option .icon {
  width: 40px;
  height: 40px;
}

.h30 {
  height: 30px;
}

.lists {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.lists .list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  box-shadow: 0px 0px 40px 0px rgba(216, 216, 216, 1);
  border-radius: 10px;
  width: calc(100% - 30px);
  height: 220px;
  background: #FFF;
  overflow: hidden;
}
.lists .list .pic {
  flex: 0 0 220px;
  width: 220px;
  height: 220px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
.lists .list .text {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 30px 20px 30px;
  width: calc(100% - 280px);
  height: 180px;
}
.lists .list .name-leave {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 45px;
  font-size: 32px;
  font-weight: bold;
  line-height: 45px;
}
.lists .list .name {
  width: calc(100% - 100px);
}
.lists .list .name-leave .leave {
  width: 96px;
  height: 32px;
}
.lists .list .descri {
  height: 80px;
  font-size: 24px;
  line-height: 40px;
  color: #666;
}
.lists .list .descri >>> a {
  color: #666 !important;
}
.lists .list .descri >>> img {
  display: none !important;
}
.lists .list .address {
  width: 100%;
  height: 30px;
  font-size: 22px;
  line-height: 30px;
  color: #999;
}
.lists .list .address .icon {
  margin-right: 5px;
  font-size: 22px;
}
</style>